import { all, call, put, takeEvery } from '@redux-saga/core/effects';
import _ from 'lodash';
import IApplicationEmail from '~Api/ApplicationEmail/IApplicationEmail';
import { parseApplicationEmail } from '~Api/ApplicationEmail/parsers';
import {
    applicationEmailTextRequest,
    applicationEmailsListRequest,
} from '~Api/ApplicationEmail/requests';
import { IFetchResponse } from '~utilities/fetch';
import {
    IApplicationEmailTextGetAction,
    IApplicationEmailsListAction,
    applicationEmailTextSetAction,
    applicationEmailsSetAction,
} from './actions';
import ApplicationEmailsActionsEnum from './ActionsEnum';

function* applicationEmailsList(action: IApplicationEmailsListAction): Iterator<unknown> {
    const response: IFetchResponse = yield call(applicationEmailsListRequest, action.applicationUuid, action.pageNumber, action.perPage);
    const count: number = parseInt(response.headers.get('X-Pagination-Total-Records'), 10);
    const emails: IApplicationEmail[] = _.map(response.body, parseApplicationEmail);

    yield put(applicationEmailsSetAction(action.applicationUuid, emails, count));
}

function* applicationEmailTextGet(action: IApplicationEmailTextGetAction): Iterator<unknown> {
    const response: IFetchResponse = yield call(applicationEmailTextRequest, action.applicationEmailUuid);

    yield put(applicationEmailTextSetAction(action.applicationEmailUuid, response.body.text));
}

export function* ApplicationEmailsSagas(): Iterator<unknown> {
    yield all([
        takeEvery(ApplicationEmailsActionsEnum.ApplicationEmailsList, applicationEmailsList),
        takeEvery(ApplicationEmailsActionsEnum.ApplicationEmailTextGet, applicationEmailTextGet),
    ]);
}
